<app-system-state-panel></app-system-state-panel>
<router-outlet></router-outlet>
